// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Client-singleClient-___singleClient__container___3Mpds","title":"src-components-Client-singleClient-___singleClient__title___1ENlg","image-container":"src-components-Client-singleClient-___singleClient__image-container___2QEfr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Client/singleClient/singleClient.css
// module id = 1071
// module chunks = 0